export default __webpack_public_path__ + "static/media/02.387fc4b4.png";